"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.executionType = exports.JobTypes = void 0;
/** The Job types (available jobTypes depend on the Job superType) */
exports.JobTypes = {
    LEARNING: 'learning',
    EVALUATION: 'evaluation',
    PREDICTION: 'prediction',
    DATAPOOL_STATISTICS: 'datapool-statistics',
    REALTIME_SCORING: 'realtime-scoring',
    BUILD_CODE_CAPSULE: 'build-code-capsule',
    RUN_CODE_CAPSULE: 'run-code-capsule',
    BUILD_APP: 'build-app',
    BUILD_ARCHETYPE: 'build-archetype',
    BUILD_ARCHETYPE_MODEL: 'build-model',
    TRANSFER: 'transfer',
    BACKUP: 'backup',
    RESTORE: 'restore',
};
exports.executionType = { OTHER: 'other', SPARK: 'spark' };
//# sourceMappingURL=job.js.map